<div class="cake-img-container"
     [class.is-vertical]="image?.isVertical"
     [style.backgroundImage]="'url(' + (image | multiUrlImage: 'original' : '/assets/img/content/default-cake-image.jpg') + ')'">
  <img #imageRef [alt]="alt">
</div>
